import React, { useState, useContext } from 'react'
import { Container } from '../../components/grid'

import { CustomBundles } from './CustomBundles'
import { BundleCart } from '../../components/bundle-cart'
import { HeroHeader } from '../../components/hero-header'
import { useBundleCart } from '../../utils/hooks/useBundleCart'
import { MessageFormat } from '@paypalcorp/worldready'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'

const Bundles = () => {
  const [filter, setFilter] = useState('')
  const media = {
    lg: 'https://www.paypalobjects.com/digitalassets/c/gifts/us/byob_d_02.mp4',
    sm: 'https://www.paypalobjects.com/digitalassets/c/gifts/us/byob_m_01.mp4',
  }

  const bundleCart = useBundleCart()
  const worldready = useContext(WorldReadyContext)

  return (
    <section>
      <HeroHeader
        headerStyle="search"
        headline={new MessageFormat(worldready, {
          id: 'pages/byob.byob.header',
        }).format()}
        mediaSrc={media}
        onSearchSubmit={setFilter}
      />
      <Container my={[3, 5]}>
        <CustomBundles filter={filter} cart={bundleCart} />
      </Container>
      <BundleCart cart={bundleCart} />
    </section>
  )
}

export default Bundles
